const { default: axiosIns } = require('@/libs/axios')

const AdsService = {

  // GET - AdApiController
  async getAds() {
    return axiosIns.get('admin/ads')
      .then(response => response.data)
  },
  // POST - AdApiController
  async getFilteredAds(filter) {
    return axiosIns.post('admin/ads/filters', filter)
      .then(response => response.data)
  },
  async getPreviewAd(adId, adInfo) {
    return axiosIns.post(`admin/ads/${adId}`, adInfo)
      .then(response => response.data)
      .catch(error => {
        throw error.response.data
      })
  },
  // PATCH - AdApiController
  async updateAdStatus(adId, status) {
    return axiosIns.patch(`admin/ads/${adId}?status=${status}`)
      .then(response => response.data)
  },

}

export default AdsService
